import moment from "moment";
import React, { useEffect, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router";
import { bindActionCreators, Dispatch } from "redux";
import styled from "styled-components";
import { validateVenue, Venue } from "sweet-global";
import BackButton from "sweet-web/components/universal/Button/BackButton";
import OutlineButton from "sweet-web/components/universal/Button/OutlineButton";
import CheckboxInput from "sweet-web/components/universal/Input/CheckboxInput";
import PhoneNumberInput from "sweet-web/components/universal/Input/PhoneNumberInput";
import Input from "sweet-web/components/universal/Input";
import { Label, SectionTitle } from "sweet-web/components/universal/Text";
import { Section, Wrapper } from "sweet-web/components/universal/View";
import UserLine from "sweet-web/components/universal/UserLine";
import { RootState } from "sweet-web/redux";
import * as selectors from "sweet-web/redux/selectors";
import {
  ActivateVenue,
  DeactivateVenue,
  UpdateVenue
} from "sweet-web/redux/venue/actions";

type Props = RouteComponentProps & ConnectedProps<typeof connector>;

const Admin: React.FC<Props> = props => {
  const { venueId } = props.match.params as { venueId: string };
  const { venueEntity, venueUsers } = props;

  const [venue, setVenue] = useState(venueEntity);

  useEffect(() => {
    setVenue(venueEntity);
  }, [venueEntity]);

  const back = async () => {
    props.history.push(`/listing/${venueId}/services`);
  };

  const save = async (update?: Partial<Venue>) => {
    if (update) {
      setVenue(v => ({
        ...v,
        ...update
      }));
    }
    await props.UpdateVenue(venueId, update ? update : venue);
  };

  const activate = async () => {
    if (
      window.confirm(
        "Are you sure you want to activate listing? This will become live and notify venue manager"
      )
    ) {
      await props.ActivateVenue(venueId);
    }
  };

  const deactivate = async () => {
    if (window.confirm("Are you sure you want to deactivate listing?")) {
      await props.DeactivateVenue(venueId);
    }
  };

  const isLinked =
    typeof venueUsers === "object" && Object.keys(venueUsers).length > 0;

  return (
    <Wrapper>
      <Section>
        <SectionTitle>Venue Manager</SectionTitle>
        {isLinked &&
          Object.values(venueUsers).map(user => (
            <UserLine user={user} key={`venue-user-${user.id}`} />
          ))}
        {!isLinked && (
          <React.Fragment>
            <Input
              title={"First Name"}
              value={venue.manager ? venue.manager.firstName : ""}
              onChange={value => {
                setVenue({
                  ...venue,
                  manager: {
                    ...venue.manager,
                    firstName: value
                  }
                });
              }}
              onBlur={() => save()}
            />
            <Input
              title={"Last Name"}
              value={venue.manager ? venue.manager.lastName : ""}
              onChange={value => {
                setVenue({
                  ...venue,
                  manager: {
                    ...venue.manager,
                    lastName: value
                  }
                });
              }}
              onBlur={() => save()}
            />
            <PhoneNumberInput
              title={"Phone Number"}
              description={"Will be texted on activation and about inquiries"}
              value={venue.manager ? venue.manager.phoneNumber : ""}
              onChange={value => {
                setVenue({
                  ...venue,
                  manager: {
                    ...venue.manager,
                    phoneNumber: value
                  }
                });
              }}
              onBlur={() => save()}
            />

            <Input
              title={"Email Address"}
              description={"Will be emailed on activation and about inquiries"}
              value={venue.manager ? venue.manager.emailAddress : ""}
              onChange={value => {
                setVenue({
                  ...venue,
                  manager: {
                    ...venue.manager,
                    phoneNumber: value
                  }
                });
              }}
              onBlur={() => save()}
            />
          </React.Fragment>
        )}
      </Section>
      <Section>
        {!venue.active && (
          <OutlineButton
            style={{ marginTop: 10 }}
            title="Activate Listing and Notify Manager"
            onClick={activate}
          />
        )}
        {venue.active && (
          <OutlineButton
            style={{ marginTop: 10 }}
            color="gray"
            title="Deactivate Listing"
            onClick={deactivate}
          />
        )}
      </Section>
      <BackButton onClick={back} />
    </Wrapper>
  );
};

const mapState = (state: RootState, ownProps: RouteComponentProps) => {
  const { venueId } = ownProps.match.params as { venueId: string };

  return {
    venueEntity: selectors.getVenue(venueId)(state),
    venueUsers: selectors.getVenueUsers(venueId)(state)
  };
};
const mapDispatch = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      ActivateVenue,
      DeactivateVenue,
      UpdateVenue
    },
    dispatch
  );
const connector = connect(mapState, mapDispatch);

export default connector(Admin);
